import { Rout_create } from './Rout.create'
import { Rout_to, Rout_construct } from './Rout'
import type { ElementId, ReportId as FlowReportId } from '../../../shared/domain/flows/types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import { type LoopPath, type LoopPathIds, toLoopPath } from '../../../shared/domain/flows/LoopPath.no-deps'

export interface Rout_FlowRoutesArgs {
    Flow_ExecutionPage: React.FunctionComponent<unknown>
    Flow_ActionExecutionPage: React.FunctionComponent<unknown>
}

export const Rout_FlowRoutes = (args: Rout_FlowRoutesArgs) => [
    Rout_create('/flow/execute/:reportId', args.Flow_ExecutionPage),
    Rout_create('/flow/action/execute/:scheduleInstanceId/:reportId', args.Flow_ActionExecutionPage),
]

export function Rout_toFlowExecutionPage(
    reportId: FlowReportId,
    opts?: {
        scrollTop?: number
        sectionId?: ElementId
        comingFromActionScheduledInstance?: boolean
        comingFromScheduledInstance?: UUID
        comingFromSubTask?: FlowReportId
        comingFromUnit?: number
        comingFromWorkflow?: number
        loopPathIds?: LoopPathIds
        scrollToElementId?: ElementId
        scrollToLoopPath?: LoopPath
        comment?: UUID
    }
) {
    Rout_to(Rout_toFlowExecutionPagePath(reportId, opts))
}

export function Rout_toFlowActionExecutionPage(
    scheduleInstanceId: UUID,
    reportId: FlowReportId,
    opts?: { sectionId?: ElementId }
) {
    Rout_to(`/flow/action/execute/${scheduleInstanceId}/${reportId}`, opts)
}

export function Rout_toFlowExecutionPagePath(
    reportId: FlowReportId,
    opts?: {
        scrollTop?: number
        sectionId?: ElementId
        scrollToElementId?: ElementId
        scrollToLoopPath?: LoopPath
        comingFromActionScheduledInstance?: boolean
        comingFromScheduledInstance?: UUID
        comingFromSubTask?: FlowReportId
        comingFromUnit?: number
        comingFromWorkflow?: number
        elementToRecover?: ElementId
        loopPathIds?: LoopPathIds
        comment?: UUID
    }
) {
    return Rout_construct(`/flow/execute/${reportId}`, {
        scrollTop: opts?.scrollTop,
        sectionId: opts?.sectionId,
        scrollToElementId: opts?.scrollToElementId,
        scrollToLoopPath: opts?.scrollToLoopPath,
        comingFromActionScheduledInstance: opts?.comingFromActionScheduledInstance,
        comingFromScheduledInstance: opts?.comingFromScheduledInstance,
        comingFromSubTask: opts?.comingFromSubTask,
        comingFromUnit: opts?.comingFromUnit,
        comingFromWorkflow: opts?.comingFromWorkflow,
        elementToRecover: opts?.elementToRecover,
        loopPath: opts?.loopPathIds ? toLoopPath(opts.loopPathIds) : [],
        comment: opts?.comment,
    })
}
